import React, { useEffect, useState } from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'

interface EmdgMainNavContentItem {
    link: string,
    text: string,
    active?: boolean
}
interface EMDGNavBarProps {

    navLinks: EmdgMainNavContentItem[]

}
export interface EMDGMainNavContentItem {
    link: string,
    text: string,
    active?: boolean
}

const EMDGNavBar = (props: EMDGNavBarProps) => {
    //    const [navLinks, setNavLinks] = useState<EmdgMainNavContentItem[]>(props.navLinks)

    //   const ExpandOrCollapse = () => {
    //     console.log(`Expanded currebt:${header}`)
    //     setHeader(header)
    //     console.log(`Expanded after click:${header}`)
    //     // if (props.onOpen && typeof props.onOpen === 'function') {
    //     //  console.log('called before call back')
    //     //  props.onOpen()
    //     // }
    //   }
    const { navLinks } = props
    useEffect(() => {
        // const fetchDataPizzeria = async () => {
        //     const response = await fetch(`https://localhost:44365/api/Pizzeria`);
        //     const newData = await response.json();
        //     setPizzeriaList(newData);
        // };
        // //fetchDataPizzaMenu();
        // fetchDataPizzeria();
        // setNavLinks(props.navLinks)
        navLinks.map(item => { console.log(item.text + ' ' + item.link + ' ' + item.active) })

    }, [])

    return (

        <Navbar variant="dark" className="emdg-main-nav  emdg-main-nav--dark d-print-none" expand="lg">

            <div className="container-fluid">

                 
                    <Navbar.Toggle aria-controls="navbarScroll" />

                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto my-2 my-lg-0 w-100 justify-content-start">
                                {navLinks.map((item: EmdgMainNavContentItem) => (
                                    <Nav.Link 
                                        key={item.link} 
                                        href={item.link} 
                                        active={item.active} 
                                        className={`${!item.active ? 'custom-nav-link' : ''} ${item.text === 'Logout' ? 'logout-link' : ''}`}
                                    >
                                        {item.text}
                                    </Nav.Link>
                                    
                                ))}
                            </Nav>
                    </Navbar.Collapse>
               

            </div>

        </Navbar>

    )
}

export default EMDGNavBar
